
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Maria Silva',
      location: 'São Paulo, SP',
      rating: 5,
      comment: 'Maravilhosa! Amei a qualidade do kit de facas e estou surpresa com os cortes, realmente são muito afiadas, só tinha visto propaganda, mas agora usando estou ainda mais surpreendida pessoalmente, chegou super rápido, em menos de 24 horas e só paguei quando chegou, compra rapida e segura',
      avatar: 'https://public.readdy.ai/ai/img_res/de304ec61646e280946c60beb81f3577.jpg',
      photo: 'https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/938a565c7e20a984a5d8bca958e107f9.png'
    },
    {
      name: 'João Santos',
      location: 'Rio de janeiro, RJ',
      rating: 5,
      comment: 'Comprei para minha esposa, pedi num dia e chegou no outro, ela ficou apaixonada! A qualidade é excelente e o preço foi muito bom, é o preço de uma faca só paga por um conjunto completo, melhor custo benefício. Chegou rapidinho e bem embalado. Deixo aqui minha recomendação sincera que vale a pena!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20middle-aged%20Brazilian%20man%20with%20dark%20hair%2C%20friendly%20smile%2C%20wearing%20casual%20shirt%2C%20clean%20white%20background%2C%20high%20quality%20headshot%20photography&width=80&height=80&seq=avatar-joao&orientation=squarish',
      photo: 'https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/d688050d578730d339b596e943cc8a67.png'
    },
    {
      name: 'Ana Costa',
      location: 'Betim, MG',
      rating: 5,
      comment: 'Melhor investimento que fiz para minha cozinha! As facas cortam perfeitamente e são muito confortáveis de usar. Vale cada centavo!',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Brazilian%20woman%20with%20long%20dark%20hair%2C%20bright%20smile%2C%20wearing%20modern%20casual%20clothing%2C%20clean%20white%20background%2C%20high%20quality%20headshot%20photography&width=80&height=80&seq=avatar-ana&orientation=squarish',
      photo: 'https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/eafb09d2bd62947d06153a0611234140.png'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            O Que Nossos Clientes Dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Mais de 10.000 clientes satisfeitos em todo o Brasil
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-600 italic leading-relaxed mb-4">
                "{testimonial.comment}"
              </p>
              
              {testimonial.photo && (
                <div className="mt-4">
                  <img 
                    src={testimonial.photo}
                    alt={`Foto do produto de ${testimonial.name}`}
                    className="w-full h-48 object-cover rounded-lg"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-2 bg-yellow-50 px-6 py-3 rounded-full">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400"></i>
              ))}
            </div>
            <span className="font-semibold text-gray-800">4.9/5</span>
            <span className="text-gray-600">• Baseado em 2.847 avaliações</span>
          </div>
        </div>
      </div>
    </section>
  );
}
